const InteractiveObject = ({ position, size, zIndex = 3, image, inActiveZone }) => {
    return (
        <div
            style={{
                position: 'absolute',
                left: position.x,
                top: position.y,
                width: size.width,
                height: size.height,
                zIndex: zIndex
            }}
        >
            {inActiveZone ? 
            <div
                style={{
                    position: 'relative',
                    width: '30px',
                    height: '30px',
                    margin: '0 auto',
                    marginTop: '-30px',
                    backgroundColor: 'gray',
                    display:'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 'bold',
                    zIndex: 200
                }}>
                    E
            </div> : ''}
            {image ? <img src={image} style={{ height: size.height, imageRendering: 'pixelated' }} /> : ''}
            
        </div>
    );
}

export default InteractiveObject